// London trusts for quick-select filtering, matched by trust NAME.
//
// `trust_id` is an internal per-environment UUID (not a stable ODS code), so a
// hardcoded id set only matches in the environment those ids were captured from
// (prod). Trust names are stable across dev/staging/prod, so we match on name —
// the same approach pathway-logic uses for `isMentalHealthTrust`. Matching
// normalises case, curly apostrophes and whitespace so punctuation/spelling
// drift doesn't matter. Project-specific UI config for this visualiser — not
// part of the core detention-period logic.
const LONDON_TRUSTS: readonly string[] = [
  "Barts Health NHS Trust",
  "North East London NHS Foundation Trust",
  "Croydon Health Services NHS Trust",
  "South West London and St George's Mental Health NHS Trust",
  "Homerton Healthcare NHS Foundation Trust",
  "Barking, Havering and Redbridge University Hospitals NHS Trust",
  "Central and North West London NHS Foundation Trust",
  "Whittington Health NHS Trust",
  "South London and Maudsley NHS Foundation Trust",
  "Oxleas NHS Foundation Trust",
  "North London NHS Foundation Trust",
  "Guy's and St Thomas' NHS Foundation Trust",
  "East London NHS Foundation Trust",
  "Epsom and St Helier University Hospitals NHS Trust",
  "St George's University Hospitals NHS Foundation Trust",
  "West London NHS Trust",
  "King's College Hospital NHS Foundation Trust",
  "Lewisham and Greenwich NHS Trust",
  "Kingston and Richmond NHS Foundation Trust",
  "University College London Hospitals NHS Foundation Trust",
  "Royal Free London NHS Foundation Trust",
  "London North West University Healthcare NHS Trust",
];

function normalise(name: string): string {
  return name.trim().toLowerCase().replace(/[‘’']/g, "'").replace(/\s+/g, " ");
}

const LONDON_SET = new Set(LONDON_TRUSTS.map(normalise));

/** True if `trustName` is one of the London trusts (matched by stable name). */
export function isLondonTrust(trustName: string | null | undefined): boolean {
  if (trustName === null || trustName === undefined || trustName === "") {
    return false;
  }
  return LONDON_SET.has(normalise(trustName));
}
